import { render, staticRenderFns } from "./UserMessageDialog.vue?vue&type=template&id=ce15bec0&scoped=true"
import script from "./UserMessageDialog.vue?vue&type=script&lang=js"
export * from "./UserMessageDialog.vue?vue&type=script&lang=js"
import style0 from "./UserMessageDialog.vue?vue&type=style&index=0&id=ce15bec0&prod&lang=scss&scoped=true"
import style1 from "./UserMessageDialog.vue?vue&type=style&index=1&id=ce15bec0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce15bec0",
  null
  
)

export default component.exports